import {combineReducers} from "redux";
import userReducer from "./userReducer";
import {i18nReducer} from "react-redux-i18n";


export default combineReducers({
    user: userReducer,
    i18n: i18nReducer
})